module.exports = __webpack_public_path__ + "assets/failure-icon-6ccc1b.svg";